// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Er9_","notes":"Notes_notes__14-xn"};